export enum Platform {
  WEB = 'webBrowser',
  MOBILE_WEB = 'mobileBrowser',
  MOBILE_NATIVE_APP = 'mobileNativeApp',
}
